/* 🤖 this file was generated by svg-to-ts */
export const siriusX: {
  name: 'x';
  data: string;
} = {
  name: 'x',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M19.28 5.78a.75.75 0 0 0-1.06-1.06L12 10.94 5.78 4.72a.75.75 0 0 0-1.06 1.06L10.94 12l-6.22 6.22a.75.75 0 1 0 1.06 1.06L12 13.06l6.22 6.22a.75.75 0 1 0 1.06-1.06L13.06 12l6.22-6.22Z" fill="currentColor"/></svg>`
};
